import React, { useState } from 'react'

import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

interface ToggablePasswordProps {
  id: string
  name: string
  label: string
  containerClassName: string
}

export default function ToggablePassword({
  id,
  name,
  label,
  containerClassName,
}) {
  const [passwordVisible, setPasswordVisible] = useState(false)

  return (
    <div className={`password-field ${containerClassName}`}>
      <input
        name='password'
        id={id}
        type={passwordVisible ? 'text' : 'password'}
        autoComplete='current-password'
        placeholder=' '
        required
        aria-required
      />
      <label htmlFor={id}>{label}</label>

      <div className='toggler'>
        <input
          id={`show_${id}`}
          type='checkbox'
          onChange={togglePasswordVisibility}
          className='visually-hidden'
        />
        <label htmlFor={`show_${id}`} onClick={togglePasswordVisibility}>
          {passwordVisible ? <Visibility /> : <VisibilityOff />}
          <span className='visually-hidden'>
            {passwordVisible ? 'Masquer' : 'Afficher'} le mot de passe
          </span>
        </label>
      </div>
    </div>
  )

  function togglePasswordVisibility() {
    setPasswordVisible(!passwordVisible)
  }
}
